export const API_ALLLEADS_GET_TOTAL_ACCOUNT_OPNED_SUCCESS =
    "API_ALLLEADS_GET_TOTAL_ACCOUNT_OPNED_SUCCESS";
export const API_ALLLEADS_GET_TOTAL_ACCOUNT_OPNED_FAIL =
    "API_ALLLEADS_GET_TOTAL_ACCOUNT_OPNED_FAIL";
export const GET_ALLLEADS_GET_TOTAL_ACCOUNT_OPNED = "GET_ALLLEADS_GET_TOTAL_ACCOUNT_OPNED";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";
export const RESET_TRADE_LEADS = "RESET_TRADE_LEADS";
